
function is_mark_layer(__) {
  /*
    determines whether a given key is a vaild mark layer key
    @_: a key
    returns boolean
  */
  return __.endsWith("marks") && !__.includes("_markLabel_");
}
function is_path_group_layer(__) {
  /*
    determines whether a given key is a vaild pathgroup layer key
    @_: a key
    returns boolean
  */
  return __.endsWith("pathgroup") && !__.includes("_markLabel_");
}
function subcontext_key_test(keys) {
  /*
    @keys: property names of the given subcontext
    determines whether the gien property of the subcontext has a vaild mark layer
    returns boolean
  */
  let _ = false;
  for (const key of keys) {
    if (is_mark_layer(key)) {
      _ = true;
      break;
    }
  }
  return _;
}

function search_best_fit_field(expr, scales) {
  /*
    search most likely field name for an calucalte expression
    @expr: calculate expression
    @scales: scales data (MsgLossVlItem -> scales_set)
    returns String
  */
  let result = {
    name: undefined,
    len: 0
  }
  for (const scale of scales) {
    let name = scale.domain.field;
    if (name && name.constructor === String) {
      if (expr.includes(name) && result.len < name.length) {
        result.name = name;
        result.len = name.length;
      }
    }
  }
  return result.name;
}


let vg_fields = [ // vega-lite-supported encoding fields
  "x", "xc", "y", "yc", "x2", "y2", "lx", "ly", "fill", "opacity", "shape", "size", "stroke", "text", "detail", "strokeWidth", "lat", "long",
];

let encoding_conversion = {
  'x': 'x',
  'x2': 'x',
  'xc': 'x',
  'y': 'y',
  'y2': 'y',
  'yc': 'y',
  'xy': 'xy',
  'lx': 'lx',
  'ly': 'ly',
  'size': 'size',
  'fill': 'color',
  'stroke': 'color',
  'opacity': 'opacity',
  'text': 'text',
  'shape': 'shape',
  'pos_sub': 'pos_sub',
  'strokeWidth': 'strokeWidth',
  'detail': 'detail',
  'lat': 'lat',
  'long': 'long',
};

export let encoding_conversion_aggregate = {
  'x': 'position',
  'x2': 'position',
  'xc': 'position',
  'y': 'position',
  'y2': 'position',
  'yc': 'position',
  'lx': 'length',
  'ly': 'length',
  'size': 'size',
  'fill': 'color',
  'stroke': 'color',
  'strokeWidth': 'strokeWidth',
  'opacity': 'opacity',
  'text': 'text',
  'shape': 'shape',
  'pos_sub': 'pos_sub',
  'detail': 'detail',
  'lat': 'position',
  'long': 'position',
};

let graph_orient = {
  vertical: 'vertical',
  horizontal: 'horizontal'
}

let vg_scale_types_by_orient = {
  quantitative: ["linear", "pow", "sqrt", "symlog", "log"],
  non_quantitative: ["time", "utc", "sequential", "band", "point", "quantile", "quantize", "threshold", "ordinal"]
}

function is_atomic(a) {
  /*
    @a: an item
    returns whether @a is Number or String
  */
  return a?.constructor === Number || a?.constructor === String;
}

function matrix_average_by_row(arr) {
  /*
    @arr: length-n array of equi-length arrays (matrix by column)
    returns the average of each row
  */
  let dim = arr[0].length;
  let n_row = arr.length;
  if (arr.every(function (e) { return e.length === dim; })) {
    let result = [];
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < dim; j++) {
        if (result[j] === undefined) result[j] = 0;
        result[j] += arr[i][j] / n_row;
      }
    }
    return result;
  } else {
    return null;
  }
}

function transpose_object(data) {
  /*
    @data: [{x: 1, y: 2, ...} ... ] / {x: [], y: [], ...}
    return the transpose of @data
  */
  if (data.constructor === Array) {
    let trans = {};
    for (let i = 0; i < data.length; i++) {
      let keys = Object.keys(data[i]);
      for (let j = 0; j < keys.length; j++) {
        let key = keys[j];
        if (!trans.hasOwnProperty(key)) trans[key] = [];
        trans[key][i] = data[i][key];
      }
    }
    return trans;
  } else if (data.constructor === Object) {
    let trans = [];
    let keys = Object.keys(data);
    let max_length = Math.max(...keys.map(function (k) { return data[k].length; }));
    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      for (let j = 0; j < max_length; j++) {
        if (trans[i] === undefined) trans[i] = {};
        trans[i][key] = data[key][i];
      }
    }
    return trans;
  }
}

function array_invariance(arr) {
  /*
    @arr: an array
    returns whether @arr has only same values;
  */
  let s = new Set();
  for (const a of arr) {
    s.add(a);
  }
  return s.size === 1;
}

export const util = {
  isMarkLayer: is_mark_layer,
  subcontextKeyTest: subcontext_key_test,
  isPathGroupLayer: is_path_group_layer,
  vgFields: vg_fields,
  vgEncConversion: encoding_conversion,
  searchBestFitField: search_best_fit_field,
  cOrient: graph_orient,
  vgScaleTypesByOrient: vg_scale_types_by_orient,
  isAtomic: is_atomic,
  matrxiAvgByRow: matrix_average_by_row,
  transposeObject: transpose_object,
  isArrayInvariant: array_invariance
};